// extracted by mini-css-extract-plugin
export default {"root":"LQ7LWnaumBnfT0gsQvzV","container":"nl5UXyWKCJDUOUDsFNkp"};